import { ChildDatasetAccessRequestsList } from "./ChildDatasetAccessRequestsList";

export const DatasetAccessRequests = () => {
  return <ChildDatasetAccessRequestsList />;
};
